import React from 'react';
import HeroStats from './HeroStats';
import ServiceShowcase from './ServiceShowcase.tsx';
import BusinessCTA from './BusinessCTA';
import SolutionsGrid from './SolutionsGrid';
import FeatureCarousel from './FeatureCarousel.tsx';
import IntegrationsSection from './IntegrationsSection.tsx';
import FreeTrialSection from './FreeTrialSection.tsx';

const AboutSection = () => {
  return (
    <>

      <ServiceShowcase />
      <BusinessCTA />
      <FeatureCarousel />
      <IntegrationsSection />
      <FreeTrialSection />
    </>
  );
};

export default AboutSection;
